import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/auth/auth.guard';
import { LoginGuard } from './core/auth/login.guard';
import { LayoutComponent } from './features/layout/layout.component';
import { UserLoginComponent } from './features/login/user-login/user-login.component';

const routes: Routes = [

  { path: 'login/user-login', component: UserLoginComponent, canActivate:[LoginGuard]},
  { 
    path: '', component: LayoutComponent,
    children: [
      {
        path: 'provider/payer',
        loadChildren: () => import('./features/provider_insurance/provider-orinsurance.module').then(provider_insurance => provider_insurance.ProviderORinsuranceModule),
      },
      {
        path: 'prescription',
        loadChildren: () => import('./features/prescription/prescription.module').then(p => p.PrescriptionModule)
      },
      {
        path: 'preferred-druglist',
        loadChildren: () => import('./features/preferred-drug-list/preferred-drug-list.module').then(pdl => pdl.PreferredDrugListModule)
      },
      {
        path: 'rule',
        loadChildren: () => import('./features/rule-config-manage/rule-config-manage.module').then(rcm => rcm.RuleConfigManageModule)
      },
      {
        path: 'authorizations',
        loadChildren: () => import('./features/authorization/authorization.module').then(p => p.AuthorizationModule)
      },
      {
        path: 'user-management',
        loadChildren: () => import('./features/user-management/user-management.module').then(p => p.UserManagementModule)
      },
      {
        path: 'settings-management',
        loadChildren: () => import('./features/settings-management/settings-management.module').then(p => p.SettingsManagementModule)
      },
      {
        path: 'acl-management',
        loadChildren: () => import('./features/acl-management/acl-management.module').then(p => p.AclManagementModule)
      },
      {
        path: 'rule-engine',
        loadChildren: () => import('./features/rule-engine/rule-engine.module').then(p => p.RuleEngineModule)
      },
      {
        path: 'master-management',
        loadChildren: () => import('./features/master-management/master-management.module').then(p => p.MasterManagementModule)
      },
      {
        path: 'role-management',
        loadChildren: () => import('./features/role-management/role-management.module').then(p => p.RoleManagementModule)
      },
      { path: '**', redirectTo: 'provider/payer', pathMatch: 'full' },
    ], canActivate: [AuthGuard],
    
    
  },
  {
    path: 'validate',
    loadChildren: () => import('./features/reset-password/reset-password.module').then(reset => reset.ResetPasswordModule), canActivate:[LoginGuard]
  },
  { 
    path: 'validate',
    loadChildren: () => import('./features/reset-password/reset-password.module').then(reset => reset.ResetPasswordModule), canActivate:[LoginGuard]
  },
]


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
